export interface SharedFile {
    id: string;
    fileDetailsId: string;
    expirationDate: Date;
    email: string;
    skipAuthenticationCheck: boolean;

    shareBehavior?: ShareBehavior;
}

export enum ShareBehavior {
    AlertIfUserExistsElseEmail, // Sends an alert if the user exists, otherwise sends an email
    AlertAndEmail,              // Sends both an alert and an email in any case
    EmailOnly                   // Only sends an email regardless of user existence
}